import React, { useContext } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import ScreenHeight from "~components/ScreenHeight";
import Cross from "~components/svg/Cross";

const DeliveryModal = () => {
  const {
    deliveryModalActive,
    setDeliveryModalActive,
    setDeliveryModalSeen
  } = useContext(AppContext);

  const { device } = useContext(DocumentContext);

  const { allDataYaml } = useStaticQuery(graphql`
    query DeliveryModal {
      allDataYaml {
        edges {
          node {
            deliveryModalHeading
            deliveryModalBody
          }
        }
      }
    }
  `);

  let deliveryModalHeading;
  let deliveryModalBody;

  if (allDataYaml?.edges?.[0]) {
    allDataYaml.edges.forEach(({ node }) => {
      if (!deliveryModalHeading && node?.deliveryModalHeading) {
        ({ deliveryModalHeading } = node);
      }
      if (!deliveryModalBody && node?.deliveryModalBody) {
        ({ deliveryModalBody } = node);
      }
    });
  }

  //

  const close = () => {
    setDeliveryModalActive(false);
    setDeliveryModalSeen(true);
  };

  //

  return (
    <ScreenHeight
      className={`delivery-modal transition-opacity ${
        deliveryModalActive
          ? `active opacity-100 pointer-events-auto`
          : `opacity-0 pointer-events-none`
      } w-screen fixed top-0 right-0 bottom-0 left-0 z-40 flex items-center justify-center pointer-events-none bg-dark-green`}
    >
      <button
        type="button"
        className="absolute top-0 right-0 z-20 mt-4 md:mt-8 mr-3 md:mr-6 p-2"
        onClick={close}
      >
        <Cross className="w-8" color="orange" />
      </button>

      {deliveryModalActive && (
        <div className="w-full relative flex items-center justify-center text-center">
          <div className="grid">
            <div className="grid-end-12 md:grid-end-8 grid-start-1 md:grid-start-3 relative">
              <h2
                className={`animation-appear-slow animation-delay-2 ${
                  device === `desktop` ? `f2` : `f3`
                } text-cream`}
              >
                {deliveryModalHeading ||
                  `You’ve missed the order cut-off time for delivery this Saturday.`}
              </h2>

              <h2
                className={`animation-appear-slow animation-delay-3 mt-2 ${
                  device === `desktop` ? `f2` : `f3`
                } text-orange`}
              >
                {deliveryModalBody ||
                  `By continuing you understand that your delivery will arrive next week. Victoria.`}
              </h2>

              <Button
                className="animation-appear-slow animation-delay-4 w-full md:w-3/4 relative block mt-8 mx-auto pt-6 pb-6 pointer-events-auto cursor-pointer"
                color="orange"
                onClick={close}
              >
                <span className="f-button">That’s okay</span>
              </Button>

              <div className="animation-appear-down-slow animation-delay-5 w-full md:w-3/4 relative mt-3 md:mt-6 mx-auto flex items-end justify-end">
                <a
                  href="mailto:info@wildwoodbakery.com.au"
                  className="pointer-events-auto hover-underline cursor-pointer"
                >
                  <p className="b1 text-orange">Help!</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </ScreenHeight>
  );
};

export default DeliveryModal;

//
